import { MAX_SEARCH_TERM_LENGTH } from '@nudool/shared';

import { coerceSizeToken } from './coerce-size-token.js';
import { DEFAULT_PAGE_SIZE_OPTIONS } from './default-page-size-options.js';
import type { ListRouteSearch } from './list-route-search.js';
import { SORT_PARAM_RE } from './sort-param-re.js';

/** Shape-only and never throws; useListTable's parseListTableSearch validates against sortMap. */
export function parseListRouteSearch(search: Record<string, unknown>): ListRouteSearch {
  const parsed: ListRouteSearch = {};

  const size = coerceSizeToken(search.size);
  if (Number.isInteger(size) && (DEFAULT_PAGE_SIZE_OPTIONS as number[]).includes(size)) {
    parsed.size = size;
  }

  if (typeof search.sort === 'string' && SORT_PARAM_RE.test(search.sort)) {
    parsed.sort = search.sort;
  }

  if (
    typeof search.q === 'string' &&
    search.q.trim() !== '' &&
    search.q.length <= MAX_SEARCH_TERM_LENGTH
  ) {
    // eslint-disable-next-line id-length -- `q` is the actual URL search-param name (rule 4).
    parsed.q = search.q;
  }

  return parsed;
}
